// What the demo visitor has tried, kept in this browser for the steps the server can't see (a
// print preview, the reports), per copy of the sample shop.
import { storageGet, storageSet } from './hooks';

const DONE = 'sos_demo_done';
/** The copy the welcome was shown for. */
export const DEMO_SEEN = 'sos_demo_welcome';

type Done = { copy: string; done: Record<string, boolean> };

export function demoDoneHere(copyId: string): Record<string, boolean> {
  const v = storageGet<Done | null>(DONE, null);
  return v && v.copy === copyId ? v.done : {};
}

export function markDemoStep(step: 'receipt' | 'reports'): void {
  const v = storageGet<Done | null>(DONE, null);
  if (!v) return;
  if (v.done[step]) return;
  storageSet(DONE, { copy: v.copy, done: { ...v.done, [step]: true } });
}

export function rememberDemoCopy(copyId: string): void {
  const v = storageGet<Done | null>(DONE, null);
  if (!v || v.copy !== copyId) storageSet(DONE, { copy: copyId, done: {} });
}
